<div class="container">
  <p>Tipo</p>
  <ul class="list-action" id="list-action">
    <li class="item-action" id="item-action-{{i}}" *ngFor="let action of listActions; let i = index"
      [ngClass]="{
        'event': indexId === 0 && action.select,
        'task': indexId === 1 && action.select,
        'reminder': indexId === 2 && action.select,
        'return': indexId === 3 && action.select,
        'visit': indexId === 4 && action.select
      }">
      <a class="action" id="btn-list-menu-{{i}}" (click)="actionItem(i)">{{ action.text }}</a>
    </li>
  </ul>
</div>